import React, { useCallback, useEffect, useState } from 'react';
import MainLayout from 'src/components/layouts/MainLayout';
import styles from 'src/styles/layout.module.css';
import { Breadcrumb, Button, Form, Input, Row, Space, Spin, Tag, Typography } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserOutlined } from '@ant-design/icons';
import tileStyles from 'src/styles/tile.module.css';

import { useForm } from 'antd/es/form/Form';
import { AppDispatch } from 'src/index';
import { useLocationsState, useLocationsValues } from 'src/features/locations/locations.hooks';
import { createLocation, fetchLocations } from 'src/features/locations/locations.state';
import { CompanyLocation } from 'src/features/locations/locations.types';

const emptyLocation: CompanyLocation = { code: '', currency: '', name: '' };

const LocationsPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const locations = useLocationsValues();
  const history = useHistory();

  const [form] = useForm();

  const [createMode, setCreateMode] = useState<boolean>(false);
  const [newEntity, setNewEntity] = useState<CompanyLocation>(emptyLocation);

  const handleCreateButtonClick = useCallback(() => {
    setCreateMode(true);
  }, []);

  const handleFormSubmit = useCallback(async () => {
    const response = await dispatch(createLocation(newEntity));

    if (createLocation.fulfilled.match(response)) {
      history.push(`/content/accounts/${response.payload.code}`);
    }
  }, [dispatch, history, newEntity]);

  return (
    <MainLayout>
      <div className={styles.mainGrid}>
        <div className={styles.breadCrumbs}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/settings/locations'>
                <Space>
                  <UserOutlined />
                  Локации
                </Space>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.contentArea}>
          <Typography.Title level={2} className={styles.title}>
            Локации
          </Typography.Title>
          <div>
            {createMode && (
              <Form
                form={form}
                validateTrigger='onBlur'
                layout='vertical'
                className={tileStyles.listTile}
                onFinish={handleFormSubmit}
              >
                <UserOutlined />
                <Form.Item name='code' rules={[{ required: true }]} noStyle>
                  <Input
                    type='text'
                    name='username'
                    placeholder='Введите код локации'
                    style={{ width: '25%' }}
                    onChange={ev => setNewEntity(e => ({ ...e, code: ev.target.value }))}
                  />
                </Form.Item>
                <Form.Item name='name' rules={[{ required: true }]} noStyle>
                  <Input
                    type='text'
                    name='username'
                    placeholder='Введите название локации'
                    style={{ width: '25%' }}
                    onChange={ev => setNewEntity(e => ({ ...e, name: ev.target.value }))}
                  />
                </Form.Item>
                <Form.Item name='currency' rules={[{ required: true }]} noStyle>
                  <Input
                    type='text'
                    name='currency'
                    placeholder='Введите название валюты'
                    style={{ width: '25%' }}
                    onChange={ev => setNewEntity(e => ({ ...e, currency: ev.target.value }))}
                  />
                </Form.Item>
                <Button htmlType='button' type='default' onClick={() => setCreateMode(false)}>
                  Отменить
                </Button>
                <Button
                  htmlType='submit'
                  type='primary'
                  disabled={newEntity.name === '' || newEntity.currency === '' || newEntity.code === ''}
                >
                  Создать
                </Button>
              </Form>
            )}
            {locations.map(c => (
              <div key={c.code} className={tileStyles.listTile}>
                <Link to={`/settings/locations/${c.code}`} className={tileStyles.tileName}>
                  <Space>
                    <UserOutlined />
                    <span>
                      {c.name} ({c.code})
                    </span>
                  </Space>
                </Link>
                <Space align='center'>{c.currency && <Tag>{c.currency}</Tag>}</Space>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.sidebar}>
          <Space>
            <Button type='primary' onClick={handleCreateButtonClick}>
              Создать новую локацию
            </Button>
          </Space>
        </div>
      </div>
    </MainLayout>
  );
};

const LocationsPageBlock: React.FC = () => {
  const dispatch = useDispatch();
  const locationsState = useLocationsState();

  useEffect(() => {
    dispatch(fetchLocations({}));
  }, [dispatch]);

  if (locationsState.isPending) {
    return (
      <MainLayout>
        <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
          <Spin size={'large'} />
        </Row>
      </MainLayout>
    );
  }

  return <LocationsPage />;
};

export default LocationsPageBlock;
